import { useForm } from 'react-hook-form';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Form.css';

function Form() {

    const [ submitButtonPressed, setSubmitButtonPressed ] = useState(false);
    const { register, handleSubmit } = useForm();
    const navigate = useNavigate();

    const onSubmit = (data) => {
        setSubmitButtonPressed(true);

        fetch("https://k7pekghmp3.execute-api.us-east-1.amazonaws.com/contact-form-submission", {
            mode: "cors",
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data)
        }).then(res => {
            if (res.ok) {
                navigate('/formSubmissionResponse/true');
            } else {
                navigate('/formSubmissionResponse/false');
            }
        }).catch(err => {
            navigate('/formSubmissionResponse/false');
        })
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <input {...register("name", { maxLength: 99 })} className="form-control mb-3" placeholder='Name' required/>
            <input {...register("email", { maxLength: 300 })} className="form-control mb-3" type='email' placeholder='Email Address' required/>
            <textarea {...register("text-body", { maxLength: 9999 })} className="form-control mb-3" type='textarea' placeholder='Your message here' required/>
            <input type='submit' value='Submit' disabled={submitButtonPressed} className="button-theme form-submit mb-5"/>
        </form>
    );
}

export default Form;